import isFQDN from 'validator/es/lib/isFQDN';
import toString from 'lodash/toString';
import { Validator } from 'components/LWForm';

export const validateDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue))) {
		return 'Please enter a valid domain name';
	}
	return '';
};

export const validateSubDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue), { require_tld: false })) {
		return 'Please enter a valid subdomain name';
	}
	return '';
};

export const validateOppId: Validator = (oppId) => {
	const stringOppId = toString(oppId);
	const isValid =
		/006[A-Za-z0-9]{12,15}/.test(stringOppId) && stringOppId.length <= 18;
	return !isValid ? 'Please enter a valid opportunity ID' : '';
};

export const validatePhoneNumber: Validator = (phoneNumber) => {
	const stringPhoneNumber = toString(phoneNumber);
	const isValid = /^[0-9extnsio.,()+ -]{2,25}$/i.test(stringPhoneNumber);
	return !isValid ? 'Please enter phone number in a valid format' : '';
};

export const validatePortNumber: Validator = (portNumber) => {
	const stringPortNumber = toString(portNumber);
	const isValid =
		/^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-9]\d{0,4})$/.test(
			stringPortNumber,
		);
	return stringPortNumber === '' || !isValid
		? 'Please provide a valid Port'
		: '';
};

export const validateLoadBalancerNodePort: Validator = (portNumber) => {
	const stringPortNumber = toString(portNumber);
	const isValid = /^(80|443)$/.test(stringPortNumber);
	return !isValid ? 'Please provide a valid Port' : '';
};
